var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-block" }, [
    _c("div", { style: _vm.colorStatus }),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("div", { staticClass: "mt-2 mb-2" }, [
          _c(
            "div",
            { staticClass: "wrap-status d-flex justify-content-start" },
            [
              _c("b-badge", { style: _vm.colorStatus, attrs: { pill: "" } }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.status.name || "") + "\n        "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wrap-status d-flex justify-content-end" },
            [
              _vm.order.priority !== 0
                ? _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.right",
                        modifiers: { hover: true, right: true }
                      }
                    ],
                    staticClass: "important",
                    attrs: {
                      name: "burn",
                      title: "Срочный заказ!",
                      scale: "1.375"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isCallCenter && _vm.order.mustAutoconfirm
                ? _c("icon", {
                    staticClass: "text-success",
                    attrs: {
                      title: "Автоподтверждение",
                      name: "check-circle",
                      scale: "1.375"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.order.idOrigin
                ? _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.right",
                        modifiers: { hover: true, right: true }
                      }
                    ],
                    attrs: {
                      title: "Заказ был совершен через сайт",
                      name: "desktop",
                      scale: "1.375"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.order.byMobile
                ? _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.right",
                        modifiers: { hover: true, right: true }
                      }
                    ],
                    attrs: {
                      title: "Заказ был совершен через мобильное приложение",
                      name: "mobile",
                      scale: "1.375"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c("span", { staticClass: "number", style: _vm.stylesNumber }, [
                _vm._v("#" + _vm._s(_vm.order.idDay))
              ]),
              _vm._v(" "),
              _c("icon", {
                staticClass: "ml-2 mr-2",
                attrs: {
                  name: _vm.notToday
                    ? "calendar-alt"
                    : _vm.planned
                    ? "stopwatch"
                    : "clock"
                }
              }),
              _vm._v(" "),
              !_vm.notToday
                ? [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.order.forTime
                            ? _vm.$options.filters.timeByFullTime(
                                _vm.order.forTime
                              )
                            : _vm.$options.filters.time(_vm.order.time)
                        ) +
                        "\n        "
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.notToday
                ? [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$options.filters.date(_vm.order.forDay)) +
                        "\n        "
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isCallCenter
                ? _c(
                    "span",
                    {
                      staticClass: "ml-3 d-flex align-items-center stats-hist",
                      attrs: { id: "ord-stats-" + _vm.order.id },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showHistory($event)
                        }
                      }
                    },
                    [
                      _c("icon", {
                        staticClass: "mr-2",
                        attrs: { name: "stream" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("История")])
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.showPayment
            ? _c(
                "div",
                [
                  _c("span", [_vm._v(_vm._s(_vm.order.typePayment.name))]),
                  _vm._v(" "),
                  _vm.order.typePayment.keyword === _vm.TYPE_PAYMENT.CARD_ONLINE
                    ? _c(
                        "b-badge",
                        {
                          attrs: {
                            pill: "",
                            variant: _vm.order.payment ? "success" : "warning"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.order.payment ? "Оплачено" : "Не оплачено"
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("span", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.isCourier
                      ? _vm.fullAddress(_vm.order, "full")
                      : _vm.fullAddress(_vm.order)
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("b", { staticStyle: { "white-space": "nowrap" } }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.order.price) +
                  "\n            ₽\n            " +
                  _vm._s(
                    _vm.order.pricePoints > 0
                      ? "(" + _vm.order.pricePoints + " Б)"
                      : ""
                  ) +
                  "\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _vm.isCourier
            ? _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      JSON.parse(_vm.order.selectedPosition)
                        ? JSON.parse(_vm.order.selectedPosition).district
                        : ""
                    ) +
                    "\n        " +
                    _vm._s(
                      JSON.parse(_vm.order.selectedPosition)
                        ? JSON.parse(_vm.order.selectedPosition).settlement
                        : ""
                    ) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center"
            },
            [
              !_vm.order.client
                ? _c(
                    "span",
                    [
                      _vm._v(
                        _vm._s(_vm.order.fio ? _vm.order.fio : "Не указано") +
                          "\n          "
                      ),
                      _c("icon", {
                        staticClass: "ml-2 mr-2",
                        attrs: { name: "phone" }
                      }),
                      _vm._v(" "),
                      _vm.showRefTel
                        ? _c(
                            "a",
                            { attrs: { href: "tel:" + _vm.order.phone } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.order.phone) +
                                  "\n          "
                              )
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(_vm.order.phone))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.order.client
                ? _c(
                    "span",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.order.client.name
                            ? _vm.order.client.name
                            : "Не указано"
                        ) + "\n          "
                      ),
                      _c("icon", {
                        staticClass: "ml-2 mr-2",
                        attrs: { name: "phone" }
                      }),
                      _vm._v(" "),
                      _vm.showRefTel
                        ? _c(
                            "a",
                            {
                              attrs: { href: "tel:" + _vm.order.client.phone }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.order.client.phone) +
                                  "\n          "
                              )
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(_vm.order.client.phone))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showCourier
                ? _c(
                    "span",
                    [
                      _c("icon", {
                        staticClass: "mr-1",
                        attrs: { name: "truck" }
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.order.courier
                              ? _vm.shortNameWorker(_vm.order.courier)
                              : "Не задан"
                          ) +
                          "\n        "
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.showPersons
            ? _c("div", [
                _vm._v(
                  "\n        Кол-во персон:\n        " +
                    _vm._s(
                      _vm.order.personNumber
                        ? _vm.order.personNumber
                        : "Не указано"
                    ) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showChange && _vm.order.change
            ? _c("div", [_vm._v("Сдача с: " + _vm._s(_vm.order.change))])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center"
            },
            [
              _c(
                "span",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("icon", {
                    staticClass: "mr-2",
                    attrs: { name: "map-marker-alt" }
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.order.point ? _vm.order.point.address : "Не указана"
                      ) +
                      "\n        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.order.partner !== null
                ? _c("b-badge", { attrs: { variant: "dark" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.partnerOptions[_vm.order.partner]) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.order.comment
            ? _c("span", { staticClass: "comment mt-1" }, [
                _vm._v(_vm._s(_vm.order.comment ? _vm.order.comment : ""))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.settlement
            ? _c("span", { staticClass: "sellement mt-1" }, [
                _vm._v(
                  _vm._s(
                    _vm.order.settlement
                      ? "Населенный пункт: " + _vm.order.settlement
                      : ""
                  )
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "workshop-stages d-flex justify-content-center" },
            _vm._l(_vm.workshops, function(workshop) {
              return _c(
                "b-badge",
                {
                  key: workshop.id,
                  staticClass: "mr-1",
                  attrs: {
                    id: "workshop-stage-" + workshop.id,
                    variant: _vm.workshopActive(
                      workshop.keyword,
                      workshop.workshopKeyword
                    )
                  }
                },
                [
                  _c("icon", {
                    attrs: {
                      name: _vm.workshopIcon(workshop.workshopKeyword),
                      scale: "1.2"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-tooltip",
                    { attrs: { target: "workshop-stage-" + workshop.id } },
                    [
                      _c("table", [
                        _c("tr", [_c("td", [_vm._v(_vm._s(workshop.status))])])
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.order.workerAccept
            ? _c("div", { staticClass: "mt-1" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.order.workerAccept
                        ? "Оператор: " +
                            _vm.shortNameWorker(_vm.order.workerAccept)
                        : "Не задан"
                    ) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "oder-block__wrapper-btn" }, [
            _vm.getCookingTargetTimes(_vm.order) && _vm.showTimer
              ? _c(
                  "div",
                  [
                    _c("TimeCounter", {
                      attrs: {
                        end: _vm.endTime,
                        displayHint: false,
                        availableSection: {
                          days: false,
                          hours: true,
                          minutes: true,
                          seconds: true
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showMapBtn
              ? _c(
                  "a",
                  {
                    class: "btn btn-primary show-on-map-btn " + _vm.mapBtnCls,
                    attrs: {
                      target: "_blank",
                      href: "https://yandex.ru/maps/?text=" + _vm.finalAddress
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      }
                    }
                  },
                  [
                    _c("icon", { staticClass: "mr-2", attrs: { name: "map" } }),
                    _vm._v("\n          Показать на карте\n        ")
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.isCallCenter
          ? _c(
              "b-tooltip",
              {
                attrs: {
                  "custom-class": "history-order-tooltip-main",
                  target: "ord-stats-" + _vm.order.id,
                  triggers: "click"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "history-order-tooltip",
                    on: {
                      mouseleave: function($event) {
                        return _vm.onBlurHistory("ord-stats-" + _vm.order.id)
                      }
                    }
                  },
                  [
                    _vm.order.statuses && _vm.order.statuses.nodes.length !== 0
                      ? _c(
                          "table",
                          _vm._l(_vm.order.statuses.nodes, function(status) {
                            return _c("tr", { key: status.id }, [
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.formatStatusTime(status.time))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v("-")]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(status.stage.name))]),
                              _vm._v(" "),
                              _c("td", [_vm._v("-")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.shortNameWorker(status.worker))
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      : _c("div", [
                          _vm._v(
                            "\n          Истории статусов по заказу не найдено\n        "
                          )
                        ])
                  ]
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e74c08f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e74c08f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderBlock.vue
// module id = null
// module chunks = 